<h1>Outbound Loads</h1>

<p-card>

  <p-table #dt
    [columns]="cols"
    [value]="combinedLoads"
    [paginator]="true"
    [rows]="20"
    [autoLayout]="true"
    [exportFilename]="'Outbound Loads'"
    (sortFunction)="customSortEvent($event)"
    [customSort]="true">

    <ng-template pTemplate="header" let-columns>
      <tr>
        <th colspan="12" style="text-align: left;">
          <div class="load-table-header">
            <div>
              <button pButton type="button" icon="pi pi-plus" (click)="startLoad()" label="Create load"></button>
              <p-toggleButton onLabel="Search"
                offLabel="Cancel Search"
                offIcon="pi pi-times"
                onIcon="pi pi-search"
                iconPos="left"
                (onChange)="changeSearchStatus(dt);"
                [(ngModel)]="searchFlag"
                class="ml"
                [styleClass]="searchFlag ? 'p-button-secondary' : 'p-state-disabled'">
              </p-toggleButton>
              <button pButton
                      class="ml"
                      type="button"
                      icon="pi pi-file"
                      (click)="dt.exportCSV()"
                      pTooltip="CSV">
              </button>

              <p-button *ngIf="siteInfo?.hasTpm" icon="pi pi-plus" class="ml" label="Create from template" (click)="openCreateFromTemplateDialog()"></p-button>
            </div>
            <p *ngIf="!searchFlag">Input search criteria to filter; press <code>Enter</code> to search all loads.</p>
            <file-import
              [label]="'Chep Import'"
              [fileFormat]="'spreadsheets'"
              (fileUploaded)="getLoads()"
              [subinventories]="subinventories">
            </file-import>
          </div>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of columns" pSortableColumn={{col.field}}>
          {{col.header}}
          <p-sortIcon field={{col.field}} attr.ariaLabel="{{col.ariaLabel}}" attr.ariaLabelAsc={{col.ariaLabelAsc}}
          attr.ariaLabelDesc={{col.ariaLabelDesc}}></p-sortIcon>
        </th>
        <th></th>
        <th></th>
      </tr>
      <tr *ngIf="!searchFlag">
        <th *ngFor="let col of columns">
          <p-columnFilter *ngIf="col.type === 'date'" [field]="col.field" [showMenu]="false">
            <ng-template pTemplate="filter" let-value let-filter="dateFilter">
              <p-calendar
                class="gridSearchField"
                appendTo="body"
                [readonlyInput]="true"
                (onSelect)="dt.filter(parseDate($event), col.field, 'dateFilter')"
                (onInput)="filterTable(dt, $event, col.field, 'dateFilter')"
                (keydown.enter)="searchLoad()">
              </p-calendar>
            </ng-template>
          </p-columnFilter>
          <p-columnFilter *ngIf="col.type !== 'date'" (keydown.enter)="searchLoad()"
                          [field]="col.field" [showMenu]="false" [matchMode]="'contains'"></p-columnFilter>
          <ng-template pTemplate="filter" let-value let-filter="filterTable">
            <input type="text" pInputText
                  [ngModel]="value"
                  (ngModelChange)="filter(dt, $event, col.field)"
                  (input)="filterTable(dt, $event, col.field)">
          </ng-template>
        </th>
      <th></th>
      <th></th>
      <tr *ngIf="!!searchResults  || loading">
        <th colspan="10">
          <div *ngIf="loading" class="centered">
            <i class="pi pi-spin pi-spinner"></i>
            Searching...
          </div>
          <div *ngIf="hasMoreRows">
            <b>More rows exist. Refine search criteria if necessary to retrieve any loads missing.</b>
          </div>
          <div *ngIf="!!searchResults && searchResults.length === 0">
            <b>No results found for criteria given</b>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-load>
      <tr [ngClass]="{'searchResults': fromSearch(load.id), 'dragover': dragged(load.id), 'dropped': dropped(load.id)}"
          (drop)="dropHandler($event)" (dragover)="dragOverHandler($event, load)" (dragleave)="dragLeaveHandler()">
        <td>
          <span *ngIf="!load.customerReferenceNumber && (load.OutboundLoadStatusId !== OutboundLoadStatus.Shipped || load.OutboundLoadStatusId !== OutboundLoadStatus.Canceled)">
            <button pButton class="p-button-secondary" icon="pi pi-arrow-right-arrow-left" label="Reassign Ref#" (click)="replaceLoad(load)"></button>
          </span>
          <span *ngIf="!!load.customerReferenceNumber">
            {{ load.customerReferenceNumber }}
          </span>
        </td>
        <td>{{ load.propakBOLNumber }}</td>
        <td>{{ load.customerSite?.chepGlobalLocationId }} - {{load.customer?.accountName}}</td>
        <td>{{ load.customerSite?.partySiteName }}</td>
        <td>{{ load.trailer?.trailerNumber }}</td>
        <td>{{ load.carrier?.carrierName }}</td>
        <td>
          <span *ngIf="load.outboundLoadStatusId !== OutboundLoadStatus.Planned">
            {{ load.loadedWorkedShift.date | date: "MM/dd/yyyy" }} {{ load.loadedWorkedShift.shift.name }}
          </span>
          <span *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Planned">
            <button pButton label="Load Trailer" icon="pi pi-download" (click)="editLoad(load)"></button>
          </span>
        </td>
        <td [ngClass]="{'canceled': load.outboundLoadStatusId === OutboundLoadStatus.Canceled }">
          <span *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Shipped && load.shippedWorkedShift?.shiftStatus === ShiftStatus.Closed">
            {{ load.shippedWorkedShift.date | date: "MM/dd/yyyy" }} {{ load.shippedWorkedShift.shift.name }}
          </span>
          <span *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Loaded">
            <button pButton icon="pi pi-arrow-right" label="Update/Ship" (click)="partialEditLoad(load)"></button>
          </span>
          <span *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Shipped && load.shippedWorkedShift?.shiftStatus === ShiftStatus.Open">
            <button pButton class="p-button-secondary" icon="pi pi-pencil" label="{{ load.shippedWorkedShift.date | date: 'MM/dd/yyyy' }} {{ load.shippedWorkedShift.shift.name }}" (click)="partialEditLoad(load)"></button>
          </span>
          <span *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Canceled">
            {{ load.canceledWorkedShift?.date | date: "MM/dd/yyyy" }} {{ load.canceledWorkedShift?.shift.name }}
          </span>
        </td>
        <td>{{ load.pooler?.accountName }}</td>
        <td>{{ totalQuantity(load.outboundLoadLineItems) }}
          <i (click)="overlayToggle($event, load.outboundLoadLineItems)" class="pi pi-info-circle"></i>
        </td>
        <td style="white-space: nowrap">
          <button pButton title="Edit" icon="pi pi-pencil" (click)="editLoad(load)"></button>
          <button pButton title="Print BOL" class="p-button-secondary" icon="pi pi-print" (click)="printLoad(load)"></button>
          <button pButton
            *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Loaded || load.outboundLoadStatusId === OutboundLoadStatus.Shipped"
            title="Cancel Load"
            class="p-button-warning"
            icon="pi pi-ban"
            (click)="cancelLoad(load)">
          </button>
          <button pButton title="Load History" icon="pi pi-book" (click)="showHistoryDialog(load)"></button>
          <button pButton
            *ngIf="load.outboundLoadStatusId === OutboundLoadStatus.Loaded || load.outboundLoadStatusId === OutboundLoadStatus.Shipped"
            class="p-button-secondary"
            title="Resend Notification"
            icon="pi pi-send"
            (click)="sendNotification(load)">
          </button>
        </td>
        <td>
          <p-button type="button" label="Files" title="Load File Upload" icon="pi pi-upload" badge="{{load.documentIds?.length}}" (click)="uploadDocument(load)"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</p-card>

<ship-load [(show)]="showShipLoad" [load]="loadToShip" (loadUpdated)="loadShipped($event)"></ship-load>

<app-cancel-load [(show)]="showCancelLoad" [load]="loadToCancel" (loadCanceled)="loadCanceled($event)"></app-cancel-load>

<p-dialog
  class="historyDialog"
  [(visible)]="showBolReplaceDialog"
  header="Replace Ref# for BOL {{selectedLoad?.propakBolNumber}}"
  [blockScroll]="true"
  appendTo="body">
  <div>
    <label>Search Reference #s</label>
    <p-autoComplete [(ngModel)]="replacementBol" field="customerReferenceNumber" [suggestions]="importedLoadBols" id="importedLoads" (completeMethod)="matchVendorBols($event)" appendTo="body">
      <ng-template pTemplate="item" let-bol>
        <div>{{bol.customerReferenceNumber}}</div>
      </ng-template>
    </p-autoComplete>
  </div>
  <ng-template pTemplate="footer">
    <confirmation-button
      [iconsOnly]="false"
      actionIcon="pi pi-check" actionText="Replace" actionClass="p-button-primary"
      confirmIcon="pi pi-check-circle" confirmText="Replace" confirmClass="p-button-primary"
      cancelText="Cancel" cancelIcon="pi pi-minus-circle"
      (actionConfirmed)="confirmBolReplace($event)" [disabled]="working">
    </confirmation-button>
  </ng-template>
</p-dialog>
<p-dialog
  class="historyDialog"
  [(visible)]="showHistory"
  header="Load History"
  [blockScroll]="true"
  appendTo="body">
  <lib-history
    [label]="historyLoad?.propakBOLNumber"
    [changeHistory]="filteredHistory"
    [actionTemplate]="historyActions"
  >
  </lib-history>
  <ng-template #historyActions>
    <button
      *ngIf="history?.length > 0"
      pButton
      (click)="showMinimalHistory = !showMinimalHistory"
      [pTooltip]="showMinimalHistory ? 'Show all history' : 'Show load and trailer number history'"
      [icon]="showMinimalHistory ? 'pi pi-filter-slash' : 'pi pi-filter'"
    >
  </button>
  </ng-template>
</p-dialog>
<p-dialog
  class="historyDialog"
  [(visible)]="showFileStorageDialog"
  header="File Storage {{uploadLoad?.propakBOLNumber}}"
  [blockScroll]="true"
  appendTo="body"
  [modal]="true"
  (onHide)="onHide()"
  (onShow)="onShow()">
 <blob-storage
   [label]="'Outbound Documents'"
   [fileTypes]="['Outbound Load']"
   [entityId]="uploadLoad?.id"
   [entityParent]="'OutboundLoads'"
   [documentIds]="uploadLoad?.documentIds"
   [siteId]="siteId">
 </blob-storage>
</p-dialog>

<app-create-outbound-load-from-template
  *ngIf="showCreateOutboundLoadTemplateDialog"
  [show]="showCreateOutboundLoadTemplateDialog"
  (onClose)="showCreateOutboundLoadTemplateDialog = false"
></app-create-outbound-load-from-template>

<p-overlayPanel #op
                [style]="{width: '450px'}"
                [showCloseIcon]="true"
                [dismissable]="true"
                appendTo="body">
  <ng-template pTemplate>
    <p-table class="centered overlay" [value]="lineItems">
      <ng-template pTemplate="header">
        <tr>
          <th>Product</th>
          <th>Quantity</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-lineItem>
        <tr>
          <td>{{getProduct(lineItem.productId)}}</td>
          <td>{{lineItem.quantity}}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
</p-overlayPanel>
